import React, {useEffect, useState} from 'react';
import {withRouter} from 'react-router-dom';

import ClientChatBoxComponent from './clientChatboxComponent';
import ChatContainerShimmerComponent from '../common/genericComponents/redesign/shimmerWithEmptyImageComponent/chatContainerShimmerComponent';
import LoaderComponent from '../common/genericComponents/redesign/loaderComponent/loaderComponent';
import MentorChatBoxComponent from './mentorChatBoxComponent';

import utilsService from '../../services/utilsService';

import VIDABOO_CONSTANTS from '../../config/consts';

import './chatBox.css';
import './chatBoxRender.css';

// class ChatBoxRender extends React.Component {
//   // componentDidMount() {
//   //   console.debug('ComponentDid mount', 'chatboxrender')
//   // }

//   openSchedule = (bfiId) => {
//     this.props.history.push(`/expertHome/calendar/${bfiId}`);
//   };
//   getTextMessage = (msg) => {
//     let newMessage = msg;
//     if (utilsService.checkIfHTML(msg) || msg.match(/@/)) {
//       newMessage = msg.replace(
//         VIDABOO_CONSTANTS.VALIDATION_PATTERNS.ANY_EMAIL_IN_STRING,
//         (url) => {
//           return `<a href=mailto:"${url}">${url}</a>`;
//         },
//       );
//     }
//     newMessage = newMessage.replace(
//       VIDABOO_CONSTANTS.VALIDATION_PATTERNS.ANY_URL,
//       (url) => {
//         let fullUrl = url;
//         if (url.match(/@/) || utilsService.checkIfHTML(newMessage)) return url;
//         if (!url.match(/^http/)) {
//           fullUrl = 'http://' + fullUrl;
//         }
//         return `<a href=${fullUrl} target="_blank" >${url}</a>`;
//       },
//     );
//     return utilsService.shouldRenderAsHTML(newMessage) ? (
//       <div
//         dir="auto"
//         className="et-chat-link"
//         dangerouslySetInnerHTML={{__html: newMessage}}
//       />
//     ) : (
//       <div dir="auto" className="et-chat-link">
//         {newMessage}
//       </div>
//     );
//   };
//   render = () => {
//     console.debug('ComponentDid mount', 'chatboxrender')
//     const {parent, fldObj, history} = this.props;
//     const {openSchedule, getTextMessage} = this;
//     return <React.Fragment>
//       {parent.state.threedOn && (
//         // <Draggable onDrag={parent.movePublisherWindow}>
//         <div className="et-cb-threed-container">
//           <ThreedComponent
//             isMentor={true} // this is the mentor side.
//             peerUserId={parent.peerUserId}
//             closeThreed={parent.closeThreed}
//           />
//         </div>
//         // </Draggable>
//       )}
//       {fldObj.isMentor && !parent.props.isDemo && (
//         <React.Fragment>
//           <MentorChatBoxComponent
//             chatBoxMessages={parent.state.chatBoxMessages}
//             sendMessage={parent.sendMessage}
//             messageToSend={parent.state.messageToSend}
//             currentUser={parent.currentUser}
//             peerName={parent.peerName}
//             peerUserId={parent.peerUserId}
//             chatRoomDto={parent.state.chatRoomDto}
//             openSchedule={openSchedule}
//             sendGA={parent.sendGA}
//             sendAudioMessageNotification={parent.sendAudioMessageNotification}
//             handleEmojiBox={parent.handleEmojiBox}
//             onTextareaChange={parent.onTextareaChange}
//             onKeyDown={parent.onKeyDown}
//             startThreedWithPeer={parent.startThreedWithPeer}
//             callState={parent.context.callState}
//             peerIsTyping={parent.state.peerIsTyping}
//             getTextMessage={getTextMessage}
//             roomNameWarn={parent.state.roomNameWarn}
//             roomName={parent.state.roomName}
//             roomNameWarnTxt={parent.state.roomNameWarnTxt}
//             handleRoomName={parent.handleRoomName}
//             handleRoomNameInput={parent.handleRoomNameInput}
//             handleRoomNameSubmit={parent.handleRoomNameSubmit}
//             peerNameRef={parent.peerNameRef}
//             onFileDrag={parent.props.onFileDrag}
//             openCloseSendFileComponent={parent.props.openCloseSendFileComponent}
//             currentSelectedFile={parent.props.currentSelectedFile}
//             showSendFileComponent={parent.props.showSendFileComponent}
//           />
//           {parent.state.displayEmojiBox && EmojiPickerComponent ? (
//             <EmojiPickerComponent
//               ref={parent.emojiPicker}
//               onClick={parent.handleEmoji}
//               showPreview={false}
//               emoji={''}
//               title={'Color'}
//               perLine={5}
//               sheetSize={32}
//             />
//           ) : null}
//         </React.Fragment>
//       )}
//       {(!fldObj.isMentor || parent.props.isDemo) && (
//         <React.Fragment>
//           <ClientChatBoxComponent
//             getTextMessage={getTextMessage}
//             chatBoxMessages={parent.state.chatBoxMessages}
//             peerIsTyping={parent.state.peerIsTyping}
//             peerUserId={parent.peerUserId}
//             messageToSend={parent.state.messageToSend}
//             onTextareaChange={parent.onTextareaChange}
//             onKeyDown={parent.onKeyDown}
//             sendMessage={parent.sendMessage}
//             handleEmojiBox={parent.handleEmojiBox}
//             chatRoomDto={parent.state.chatRoomDto}
//             sendAudioMessageNotification={parent.sendAudioMessageNotification}
//             sendGA={parent.sendGA}
//             dispatchConsoltoEvents={parent.dispatchConsoltoEvents}
//             mentor={parent.props.mentor}
//             isDemo={parent.props.isDemo}
//             selectedWidgetAppType={parent.props.selectedWidgetAppType}
//             openCloseSendFileComponent={parent.props.openCloseSendFileComponent}
//             currentSelectedFile={parent.props.currentSelectedFile}
//             showSendFileComponent={parent.props.showSendFileComponent}
//           />
//           {parent.state.displayEmojiBox && EmojiPickerComponent? (
//             <EmojiPickerComponent
//               ref={parent.emojiPicker}
//               onClick={parent.handleEmoji}
//               showPreview={false}
//               emoji={''}
//               title={'Consolto'}
//             />
//           ) : null}
//         </React.Fragment>
//       )}
//     </React.Fragment>
//   }
// }
const ChatBoxRender = ({parent, history, isEngagerEnabled}) => {
  const [EmojiPickerComponent, setEmojiPickerComponent] = useState(null);
  const [emojiData, setEmojiData] = useState(null);
  useEffect(() => {
    loadEmojiPickerPicker();
  }, []);

  const loadEmojiPickerPicker = async () => {
    // await import('emoji-mart/css/emoji-mart.css'); --emoji-mart v4+ (and later) removed the CSS import path (emoji-mart/css/emoji-mart.css). Instead, it uses styles internally or provides other ways to import styles.
    // setEmojiPickerComponent(() => Picker);
    try {
      const [emojiPickerModule, dataModule] = await Promise.all([
        import('@emoji-mart/react'),
        import('@emoji-mart/data'),
      ]);
      setEmojiPickerComponent(() => emojiPickerModule.default);
      setEmojiData(dataModule.default);
    } catch (error) {
      console.error('Failed to load emoji picker:', error);
    }
  };

  const openSchedule = (bfiId) => {
    history.push(`${VIDABOO_CONSTANTS.ROUTES_PATH.SCHEDULING}/${bfiId}`);
    // history.push(`/expertHome/calendar`, {
    //   bfiId: bfiId,
    // });
  };
  const getTextMessage = (msg) => {
    let newMessage = msg;
    if (utilsService.checkIfHTML(msg) || msg.match(/@/)) {
      newMessage = msg.replace(
        VIDABOO_CONSTANTS.VALIDATION_PATTERNS.ANY_EMAIL_IN_STRING,
        (url) => {
          return `<a href=mailto:"${url}">${url}</a>`;
        },
      );
    }
    newMessage = newMessage.replace(
      VIDABOO_CONSTANTS.VALIDATION_PATTERNS.ANY_URL,
      (url) => {
        let fullUrl = url;
        if (url.match(/@/) || utilsService.checkIfHTML(newMessage)) return url;
        if (!url.match(/^http/)) {
          fullUrl = 'http://' + fullUrl;
        }
        return `<a href=${fullUrl} target="_blank" >${url}</a>`;
      },
    );
    newMessage = newMessage.replace(/\n/g, '<br />');
    const lineBreakRegex = new RegExp('<br ?/?>');

    if (
      utilsService.shouldRenderAsHTML(newMessage) ||
      lineBreakRegex.test(newMessage)
    ) {
      newMessage = newMessage.replace(/<iframe/g, '&lt;iframe');
      newMessage = newMessage.replace(/<script/g, '&lt;script');
      newMessage = newMessage.replace(/<\/script/g, '&lt;/script');
    }
    return utilsService.shouldRenderAsHTML(newMessage) ||
      lineBreakRegex.test(newMessage) ? (
      <div
        dir="auto"
        className="et-chat-link"
        dangerouslySetInnerHTML={{__html: newMessage}}
      />
    ) : (
      <div dir="auto" className="et-chat-link">
        {newMessage}
      </div>
    );
  };

  return (
    <React.Fragment>
      {parent.props.isMentor && !parent.props.isDemo && (
        <React.Fragment>
          {parent.state.showChatBoxMessagesShimmer &&
          !parent.state.showPreviousMessagesShimmer ? (
            <ChatContainerShimmerComponent />
          ) : (
            <>
              {parent.state.showPreviousMessagesShimmer && (
                <div className="et-chat-box-msg-loader-wrap">
                  <LoaderComponent />
                </div>
              )}
              <MentorChatBoxComponent
                isGroupChatRoom={
                  parent.props.chatRoomDto?.roomType ===
                  VIDABOO_CONSTANTS.CHAT_ROOM_TYPES.ONE_TO_MANY
                }
                isTeamChatRoom={
                  parent.props.chatRoomDto?.ownerObjectType ===
                  VIDABOO_CONSTANTS.CHAT_ROOM_OWNER_TYPE.TEAM_MENTOR
                }
                isWsConnected={parent.state.isWsConnected}
                scrollToSelectedMessage={
                  parent.props.roomDtoFromChatCenter.scrollToSelectedMessage
                }
                chatBoxMessages={parent.state.chatBoxMessages}
                reloadChatBoxMessages={parent.reloadChatBoxMessages}
                getMessagesHistory={parent.getMessagesHistory}
                showLoadMore={parent.state.showLoadMore}
                sendMessage={parent.sendMessage}
                messageToSend={parent.state.messageToSend}
                currentUser={parent.props.currentUser}
                peerName={parent.peerName}
                peerUserId={parent.props.peerUserId}
                chatRoomDto={parent.props.chatRoomDto}
                myParticipantId={parent.myParticipantId}
                myParticipantType={parent.myParticipantType}
                openSchedule={openSchedule}
                sendGA={parent.sendGA}
                sendAudioMessageNotification={
                  parent.sendAudioMessageNotification
                }
                handleEmojiBox={parent.handleEmojiBox}
                onTextareaChange={parent.onTextareaChange}
                onKeyDown={parent.onKeyDown}
                startThreedWithPeer={parent.startThreedWithPeer}
                callState={parent.context.callState}
                peerIsTyping={parent.state.peerIsTyping}
                typingParticipantsInfoObj={
                  parent.state.typingParticipantsInfoObj
                }
                sendUserStoppedTyping={parent.sendUserStoppedTyping}
                getTextMessage={getTextMessage}
                roomNameWarn={parent.state.roomNameWarn}
                roomName={parent.state.roomName}
                roomNameWarnTxt={parent.state.roomNameWarnTxt}
                handleRoomName={parent.handleRoomName}
                handleRoomNameInput={parent.handleRoomNameInput}
                handleRoomNameSubmit={parent.handleRoomNameSubmit}
                chatTextAreaRef={parent.chatTextAreaRef}
                peerNameRef={parent.peerNameRef}
                onFileDrag={parent.props.onFileDrag}
                openCloseSendFileComponent={
                  parent.props.openCloseSendFileComponent
                }
                currentSelectedFile={parent.props.currentSelectedFile}
                showSendFileComponent={parent.props.showSendFileComponent}
                showNewMsgPopup={parent.state.showNewMsgPopup}
                goToChatEnd={parent.goToChatEnd}
                isEngagerEnabled={isEngagerEnabled}
                isCustomerAvailableForInteraction={parent.isCustomerAvailableForInteraction()}
                isTakeOwnershipFlowRunning={
                  parent.props.isTakeOwnershipFlowRunning
                }
                handleTransitionChatRoomOwnership={
                  parent.props.handleTransitionChatRoomOwnership
                }
                handleTaskOwnerLockChange={
                  parent.props.handleTaskOwnerLockChange
                }
                handleTransitionToMentorChat={
                  parent.props.handleTransitionToMentorChat
                }
                deleteMessageById={parent.deleteMessageById}
                deleteConversation={parent.deleteConversation}
              />
              {parent.state.displayEmojiBox && EmojiPickerComponent && (
                <div
                  className="et-chatbox-emoji-picker-wrapper"
                  ref={parent.emojiPicker}>
                  <EmojiPickerComponent
                    data={emojiData}
                    onEmojiSelect={parent.handleEmoji}
                    previewPosition="none"
                    emojiButtonSize={32}
                    dynamicWidth={true}
                    title="Color"
                    // theme="light" can use this for light background
                  />
                </div>
              )}
            </>
          )}
        </React.Fragment>
      )}
      {(!parent.props.isMentor || parent.props.isDemo) && (
        <React.Fragment>
          <ClientChatBoxComponent
            isGroupChatRoom={
              parent.props.chatRoomDto?.roomType ===
              VIDABOO_CONSTANTS.CHAT_ROOM_TYPES.ONE_TO_MANY
            }
            isTeamChatRoom={
              parent.props.chatRoomDto?.ownerObjectType ===
              VIDABOO_CONSTANTS.CHAT_ROOM_OWNER_TYPE.TEAM_MENTOR
            }
            chatInitialized={parent.state.chatInitialized}
            getTextMessage={getTextMessage}
            chatBoxMessages={parent.state.chatBoxMessages}
            peerIsTyping={parent.state.peerIsTyping}
            typingParticipantsInfoObj={parent.state.typingParticipantsInfoObj}
            sendUserStoppedTyping={parent.sendUserStoppedTyping}
            peerUserId={parent.peerUserId}
            messageToSend={parent.state.messageToSend}
            onTextareaChange={parent.onTextareaChange}
            onKeyDown={parent.onKeyDown}
            sendMessage={parent.sendMessage}
            handleEmojiBox={parent.handleEmojiBox}
            myParticipantId={parent.myParticipantId}
            myParticipantType={parent.myParticipantType}
            chatRoomDto={parent.props.chatRoomDto}
            sendAudioMessageNotification={parent.sendAudioMessageNotification}
            sendGA={parent.sendGA}
            dispatchConsoltoEvents={parent.dispatchConsoltoEvents}
            mentor={parent.props.mentor}
            isDemo={parent.props.isDemo}
            selectedWidgetAppType={parent.props.selectedWidgetAppType}
            chatTextAreaRef={parent.chatTextAreaRef}
            openCloseSendFileComponent={parent.props.openCloseSendFileComponent}
            currentSelectedFile={parent.props.currentSelectedFile}
            showSendFileComponent={parent.props.showSendFileComponent}
            showNewMsgPopup={parent.state.showNewMsgPopup}
            goToChatEnd={parent.goToChatEnd}
            show
            showLeadCollector={parent.props.showLeadCollector}
            isPersonalPage={parent.props.isPersonalPage}
            callSendMessageFunc={parent.props.callSendMessageFunc}
            callbackSuccessInfoSend={parent.props.callbackSuccessInfoSend}
            addLocalMessageInChatBoxMessages={
              parent.addLocalMessageInChatBoxMessages
            }
            doWhenActionClick={parent.props.doWhenActionClick}
            onFooterOptionSelected={parent.props.onFooterOptionSelected}
          />

          {parent.state.displayEmojiBox && EmojiPickerComponent ? (
            <div
              className="et-chatbox-emoji-picker-wrapper"
              ref={parent.emojiPicker}>
              <EmojiPickerComponent
                ref={parent.emojiPicker}
                data={emojiData}
                onEmojiSelect={parent.handleEmoji}
                perLine={5}
                previewPosition="none"
                title={
                  !parent.props.mentor?.mentorDto?.appControlDto?.whiteLabel &&
                  'Consolto'
                }
              />
            </div>
          ) : null}
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default withRouter(ChatBoxRender);
